module.exports = __webpack_public_path__ + "static/media/icono-savora.74dfdc33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-savora.png
// module id = 305
// module chunks = 0